import { img2 } from "../../components/images";
import jsPDF from "jspdf";
import dayjs from "dayjs";

export default function generateReceiptPdf(cls) {
	const doc = new jsPDF();

	// --- PAGE SETUP & CONSTANTS ---
	const pageWidth = doc.internal.pageSize.getWidth();
	const pageHeight = doc.internal.pageSize.getHeight();
	const margin = 15;
	const startX = margin;
	const headerY = 50;
	const bottomMargin = 20; // leave space for footer/save name
	const colWidths = [18, 45, 12, 32, 23, 25, 25];
	const headers = ["Class ID", "Title", "#Std", "Instructor", "Block", "Start", "End"];

	// helper to draw the column headers
	function drawTableHeader(y) {
		doc.setFont(undefined, "bold");
		headers.forEach((h, i) => {
			const x = startX + colWidths.slice(0, i).reduce((a, b) => a + b, 0);
			doc.rect(x, y, colWidths[i], 10);
			doc.text(h, x + 2, y + 7);
		});
		doc.setFont(undefined, "normal");
	}

	// --- BRANDING & TITLE ---
	doc.addImage(img2, "PNG", pageWidth - margin - 25, 15, 25, 25);
	doc.setFontSize(16);
	doc.text("SPOT Submission Receipt", pageWidth / 2, 30, { align: "center" });
	doc.setFontSize(10);
	doc.text(`Date: ${dayjs().format("DD/MM/YYYY")}`, margin, 40);

	// --- START TABLE ---
	let currentY = headerY;
	drawTableHeader(currentY);

	// after drawing headers, bump down to first data row
	currentY += 10;

	cls.forEach((c) => {
		// calculate row height based on # of instructors
		const numInst = c.roles.length;
		const rowHeight = 10 + Math.max(0, numInst - 1) * 7;

		// if this row would go past bottomMargin, add new page & redraw header
		if (currentY + rowHeight > pageHeight - bottomMargin) {
			doc.addPage();
			currentY = headerY;
			drawTableHeader(currentY);
			currentY += 10;
		}

		// build the cell values
		const vals = [
			c.classid.toString(),
			c.ctitle.substring(0, 24) + "...", // limit title to 45 chars
			c.csize.toString(),
			c.roles.map((r) => r.name).join(";"),
			c.form,
			dayjs(c.survey_start).format("DD/MMM/YYYY"),
			dayjs(c.survey_end).format("DD/MMM/YYYY"),
		];
		const isExcluded = c.evaluate === "No";
		doc.setTextColor(isExcluded ? "red" : "black");

		// draw each cell in this row
		vals.forEach((v, colIndex) => {
			const x = startX + colWidths.slice(0, colIndex).reduce((a, b) => a + b, 0);
			doc.rect(x, currentY, colWidths[colIndex], rowHeight);

			// instructors get split onto multiple lines
			if (colIndex === 3 && v.includes(";")) {
				v.split(";").forEach((line, i) => {
					const [last, first] = line.split(", ");
					const lineText = `${last}, ${first && first.charAt(0)}`;
					doc.text(lineText, x + 2, currentY + 7 + i * 7);
				});
			} else if (colIndex === 3 && v.length > 15) {
				const [last, first] = v.split(", ");
				if (last.length > 15) {
					const lastPart = last.length > 15 ? last.substring(0, 12) + "..." : last;

					const lineText = `${lastPart}`;
					doc.text(lineText, x + 2, currentY + 7);
				} else {
					doc.text(`${last}, ${first && first?.charAt(0)}`, x + 2, currentY + 7);
				}
			} else {
				doc.text(v, x + 2, currentY + 7);
			}
		});

		// move down for next row
		currentY += rowHeight;
	});

	// --- SAVE PDF ---
	const filename = `SubmissionReceipt_${dayjs().format("YYYYMMDD_HHmm")}.pdf`;
	doc.save(filename);
}
